/**
 * /app/descuentos — Hub: cupones + promociones automáticas.
 */
import { createFileRoute } from "@tanstack/react-router";
import { DashboardCard, MERCHANT_HUB_GRID } from "@/components/ds";
import { CrudShellHeader } from "@/components/ds/CrudShell";
import { ClinicalPageShell } from "@/components/clinical";
import { DESCUENTOS_HUB_LINKS } from "@/lib/workspace-hubs";
import { MerchantExperienceBar } from "@/components/renata/MerchantExperienceBar";

export const Route = createFileRoute("/app/descuentos")({
  component: DescuentosPage,
  head: () => ({ meta: [{ title: "Incentivos de venta — Structura Market" }] }),
});

function DescuentosPage() {
  return (
    <div>
      <CrudShellHeader title="Incentivos de venta" description="Cupones, promociones y ruleta de descuentos" />
      <ClinicalPageShell offset="none" className="pt-6">
        <MerchantExperienceBar screenId="descuentos" />
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">¿Qué querés configurar?</p>
        </div>
        <div className={MERCHANT_HUB_GRID} data-tour="workspace-hub">
          {DESCUENTOS_HUB_LINKS.map((link) => (
            <DashboardCard
              key={link.id}
              to={link.href}
              search={link.search}
              icon={link.icon}
              title={link.label}
              subtitle={link.description ?? ""}
            />
          ))}
        </div>
      </ClinicalPageShell>
    </div>
  );
}
